import { useLocation } from 'react-router'

/** Navegação principal do cabeçalho (desktop). */
export const MAIN_NAV = [
  { to: '/propostas', label: 'Propostas' },
  { to: '/como-funciona', label: 'Como funciona' },
  { to: '/sobre', label: 'Sobre' },
] as const

/** Páginas secundárias, agrupadas como no rodapé e no menu "Mais" do celular. */
export const SECONDARY_NAV = [
  {
    title: 'Participar',
    links: [
      { to: '/propostas', label: 'Propostas' },
      { to: '/propor', label: 'Apresentar proposta' },
      { to: '/como-funciona', label: 'Como funciona' },
    ],
  },
  {
    title: 'Transparência',
    links: [
      { to: '/regras', label: 'Regras de participação' },
      { to: '/moderacao', label: 'Registro de moderação' },
      { to: '/sobre', label: 'Sobre o Poder Aberto' },
    ],
  },
  {
    title: 'Legal',
    links: [
      { to: '/termos', label: 'Termos de Uso' },
      { to: '/privacidade', label: 'Política de Privacidade' },
    ],
  },
] as const

/**
 * Telas de detalhe e de formulário não mostram a navegação inferior do celular, como nos
 * aplicativos: a proposta tem a própria barra de participação, e nos formulários o teclado
 * precisa do espaço.
 */
export function isTabBarHidden(pathname: string): boolean {
  return /^\/propostas\/[^/]+/.test(pathname) || /^\/(propor|entrar|cadastro|admin)(\/|$)/.test(pathname)
}

export function useTabBarVisible(): boolean {
  const { pathname } = useLocation()
  return !isTabBarHidden(pathname)
}
